export default {
  isEnabled(state) {
    return state.enabled;
  },
  getShortcuts(state) {
    return state.shortcuts;
  },
};
